require('./brokerTransferExternalValueView.scss');

const PropTypes = require('prop-types');

// @ vendor
const React = require('react');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');
// @ commons
const { formatText, FormattedText } = require('core/i18n').i18n;
const { OKCover } = require('commonsComponents/OKCover');
// @ actions
const brokerTransferExternalValuesActions = require('actions/brokerTransferExternalValues');
const accountsActions = require('actions/getAccounts');
const brokerContractValues = require('actions/brokerContractValues');
const BrokerSearchAction = require('actions/brokerSearch');
// @ components
const { OKButton } = require('components/commons/OKButton/OKButton');
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const WizardError = require('components/commons/wizardError/wizardError');
const BrokerTransferExternalStep1 = require('components/broker/brokerTransferExternalValuesSteps/brokerTransferExternalStep1/brokerTransferExternalStep1');
const BrokerTransferExternalStep2 = require('components/broker/brokerTransferExternalValuesSteps/brokerTransferExternalStep2/brokerTransferExternalStep2');
const BrokerTransferExternalStep3 = require('components/broker/brokerTransferExternalValuesSteps/brokerTransferExternalStep3/brokerTransferExternalStep3');
const BrokerTransferExternalSuccessStep = require('components/broker/brokerTransferExternalValuesSteps/brokerTransferExternalSuccessStep/brokerTransferExternalSuccessStep');
const BrokerTransferExternalSidebar = require('components/broker/brokerTransferExternalSideBar/brokerTransferExternalSideBar');
const BrokerTruncatedBreadcrumb = require('components/broker/brokerTruncatedBreadcrumb/brokerTruncatedBreadcrumb');
// @constants
const { BROKER_STOCKS_HELP_URL, MYPROFILE_BROKER_URL } = require('constants/index');

// @helpers
const { getDocumentURL } = require('utilities/stringHelper');

class BrokerTransferExternalValuesView extends React.Component {
    constructor(props) {
        super(props);

        this.handleCancel = this.handleCancel.bind(this);
    }

    componentWillMount() {
        //Hack for reload same url within react router redux state  - param init will be set when on success step,
        //back to initial step wizardSuccess button action.
        //by replacing url will allow to set init param in the url on success step and reload the view.
        if (this.props.match.params.init) {
            this.props.history.replace(`/myprofile/broker/transferExternalValues`);
        }
    }

    componentDidMount() {
        this.props.requestAccounts();
        this.props.getTraspassFunds();
    }

    componentWillUnmount() {
        this.props.reset();
        this.props.clearRequest();
    }

    buildErroneous() {
        const title = formatText('broker-transferValuesErrorTitle');
        const goBackButtonLabel = formatText('broker-transferValuesBack').toUpperCase();
        const linkToMovements = `/myprofile/broker/general`;
        const goBackButton = {
            label: goBackButtonLabel,
            url: linkToMovements
        }

        return (
            <div className="row no-gutter">
                <div className="col-xs-offset-2 col-xs-8">
                    <WizardError
                        errorMessage={title}
                        mainButton={goBackButton}
                    >
                        <FormattedText
                            value="broker-transferValuesErrorMessage"
                        />
                    </WizardError>
                </div>
            </div>
        )
    }

    buildHeader(){
        const { immVariables } = this.props;
        const fees_url = getDocumentURL(immVariables.getIn(['variables', 'parameters', 'documents_urls', 'investments', 'wealth_rate']));
        const mappingBreadcrumb = [
            {
                text: formatText('breadcrumb-brokerInvestments'),
                url: MYPROFILE_BROKER_URL
            },
            {
                text: formatText('breadcrumb-brokerTransferExternalValues')
            }
        ];
        return (
            <BrokerTruncatedBreadcrumb
                titleKey="broker-transferExternalValuesTitle"
                breadcrumbConfig={mappingBreadcrumb}
            >
                <OKButton
                    inverse={true}
                    modifier="ghost"
                    to={BROKER_STOCKS_HELP_URL}
                >
                    {formatText('broker-transferExternalSecondLinkLabel')}
                </OKButton>
                <OKButton
                    modifier="primary"
                    to={fees_url}
                >
                    {formatText('broker-transferExternalFirstLinkLabel')}
                </OKButton>
            </BrokerTruncatedBreadcrumb>
        );
    }

    buildSuccessful() {
        const { immTransferExternalValues, immTraspassFunds } = this.props;

        return (
            <div className="row no-gutter">
                <div className="col-xs-offset-2 col-xs-8">
                    <BrokerTransferExternalSuccessStep
                        immTransferExternalValues={immTransferExternalValues}
                        immTraspassFunds={immTraspassFunds}
                    />
                </div>
            </div>
        )
    }


    buildWizard() {
        const {
            immTransferExternalValues,
            immTraspassFunds,
            setAccountTo,
            validateStep,
            setVisibleStep,
            setWillCancel,
            setAgencieContract,
            setISNISO,
            setTitleAmount,
            getAgencies,
            setAgencie,
            searchProducts,
            handleSearchProduct,
            handleSearchReset,
            getValueAndEmitionCode,
            setContract,
            setContractBank,
            setContractOffice,
            setContractDc,
            setTypeBoB,
            setTypeAgencie
        } = this.props;

        const immSteps = immTransferExternalValues.get('steps');
        const stepLoading = immTransferExternalValues.get('isFetching');
        const actions = {
            validateStep,
            setVisibleStep,
            setWillCancel,
            finish: this.props.handleFinish,
            cancel: this.handleCancel
        };

        return (
            <Wizard
                actions={actions}
                immSteps={immSteps}
                stepsAmount={immSteps.size}
                visibleStep={immTransferExternalValues.get('visibleStep')}
            >
                <WizardStep position="first" cancelButton={true} >
                    <BrokerTransferExternalStep1
                        immTransferExternalValues={immTransferExternalValues}
                        immTraspassFunds={immTraspassFunds}
                        setAccountTo={setAccountTo}
                        setAgencieContract={setAgencieContract}
                        getAgencies={getAgencies}
                        setAgencie={setAgencie}
                        setContract={setContract}
                        setContractBank={setContractBank}
                        setContractOffice={setContractOffice}
                        setContractDc={setContractDc}
                        setTypeBoB={setTypeBoB}
                        setTypeAgencie={setTypeAgencie}
                    />
                </WizardStep>
                <WizardStep
                    position="middle"
                    cancelButton={true}
                    isLoading={stepLoading}
                >
                    <BrokerTransferExternalStep2
                        immTransferExternalValues={immTransferExternalValues}
                        setISNISO={setISNISO}
                        setTitleAmount={setTitleAmount}
                        searchState={searchProducts}
                        onHandleSearch={handleSearchProduct}
                        onHandleSearchReset={handleSearchReset}
                        getValueAndEmitionCode={getValueAndEmitionCode}
                    />
                </WizardStep>
                <WizardStep
                    position="last"
                    cancelButton={true}
                    immFinalButton="broker-transferExternalValuesFinish"
                    addLoadingBehaviour={true}
                    isLoading={stepLoading}
                >
                    <BrokerTransferExternalStep3
                        immTransferExternalValues={immTransferExternalValues}
                        immTraspassFunds={immTraspassFunds}
                    />
                </WizardStep>
            </Wizard>
        )
    }

    handleCancel() {
        this.props.history.push(`/myprofile/broker`);
    }

    render() {
        const { immTransferExternalValues, immTraspassFunds } = this.props;
        const header = this.buildHeader();
        let bodyContent;

        if (immTransferExternalValues.get('submitSuccessful')) {
            bodyContent = this.buildSuccessful();
        } else if (immTransferExternalValues.get('submitError')) {
            bodyContent = this.buildErroneous();
        } else {
            const wizard = this.buildWizard();

            bodyContent = (
                <div className="row no-outside-gutter">
                    <div className="col-xs-8">
                        {wizard}
                    </div>
                    <div className="col-xs-4">
                        <BrokerTransferExternalSidebar
                            immTransferExternalValues={immTransferExternalValues}
                            immTraspassFunds={immTraspassFunds}
                        />
                    </div>
                </div>
            );
        }

        return (
            <article className="card-deposit-money">
                <OKCover size="medium">
                    {header}
                </OKCover>
                <section className="card-deposit-money__body">
                    {bodyContent}
                </section>
            </article>
        );
    }
}

BrokerTransferExternalValuesView.propTypes = {
    history: PropTypes.object.isRequired,
    immStocksContracts: PropTypes.object.isRequired,
    immTransferExternalValues: PropTypes.object.isRequired,
    immTraspassFunds: PropTypes.object.isRequired,
    immVariables: PropTypes.object.isRequired,
    requestAccounts: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    handleFinish: PropTypes.func.isRequired,
    clearRequest: PropTypes.func.isRequired,
    setAccountTo: PropTypes.func.isRequired,
    getContractValues: PropTypes.func.isRequired,
    setAgencieContract: PropTypes.func.isRequired,
    setISNISO: PropTypes.func.isRequired,
    setTitleAmount: PropTypes.func.isRequired,
    getTraspassFunds: PropTypes.func.isRequired,
    getAgencies: PropTypes.func.isRequired,
    setAgencie: PropTypes.func.isRequired,
    searchProducts: PropTypes.object.isRequired,
    handleSearchProduct: PropTypes.func.isRequired,
    handleSearchReset: PropTypes.func.isRequired,
    getValueAndEmitionCode: PropTypes.func.isRequired,
    setTypeBoB: PropTypes.func.isRequired,
    setTypeAgencie: PropTypes.func.isRequired,
    setContract: PropTypes.func.isRequired,
    setContractBank: PropTypes.func.isRequired,
    setContractOffice: PropTypes.func.isRequired,
    setContractDc: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired
};

module.exports.constructor = BrokerTransferExternalValuesView;
module.exports.BrokerTransferExternalValuesView = connect(
state => ({
    immTransferExternalValues: state.brokerTransferExternalValues,
    immTraspassFunds: state.brokerTransferExternalFunds,
    immVariables: state.globalVariables,
    searchProducts: state.brokerSearch,
}),{
    requestAccounts: accountsActions.requestAccounts,
    validateStep: brokerTransferExternalValuesActions.validateStep,
    setVisibleStep: brokerTransferExternalValuesActions.setVisibleStep,
    setWillCancel: brokerTransferExternalValuesActions.setWillCancel,
    handleFinish: brokerTransferExternalValuesActions.finish,
    clearRequest: brokerTransferExternalValuesActions.reset,
    setAccountTo: brokerTransferExternalValuesActions.setAccountTo,
    setAgencieContract: brokerTransferExternalValuesActions.setAgencieContract,
    getContractValues: brokerContractValues.getContractValues,
    setISNISO: brokerTransferExternalValuesActions.setISNISO,
    setTitleAmount: brokerTransferExternalValuesActions.setTitleAmount,
    getTraspassFunds: brokerTransferExternalValuesActions.getTraspassFunds,
    getAgencies: brokerTransferExternalValuesActions.getAgencies,
    setAgencie: brokerTransferExternalValuesActions.setAgencie,
    handleSearchProduct: BrokerSearchAction.searchProduct,
    handleSearchReset: BrokerSearchAction.clearResults,
    getValueAndEmitionCode: brokerTransferExternalValuesActions.getValueAndEmitionCode,
    setTypeBoB: brokerTransferExternalValuesActions.setTypeBoB,
    setTypeAgencie: brokerTransferExternalValuesActions.setTypeAgencie,
    setContract: brokerTransferExternalValuesActions.setContract,
    setContractBank: brokerTransferExternalValuesActions.setContractBank,
    setContractOffice: brokerTransferExternalValuesActions.setContractOffice,
    setContractDc: brokerTransferExternalValuesActions.setContractDc,
    reset: brokerTransferExternalValuesActions.reset
})(withRouter(BrokerTransferExternalValuesView));
